import { similarityFeatureDisplay } from "./similarSeasonsFeatureGlossary";

const MULTI_TEAM_IDS = new Set(["TOT", "2TM", "3TM"]);

function isMultiTeamId(teamId) {
  return MULTI_TEAM_IDS.has(String(teamId || "").toUpperCase());
}

export function nbaSimilarityStatLabel(metric, fallback) {
  return similarityFeatureDisplay(metric, fallback).label;
}

export function formatNbaSimilarityStat(metric, value) {
  return similarityFeatureDisplay(metric).format(value);
}

export function nbaTeamLabel(teamId) {
  if (!teamId) return null;
  if (isMultiTeamId(teamId)) return "Multiple teams";
  return teamId;
}

export function nbaTeamLogoId(teamId) {
  if (!teamId || isMultiTeamId(teamId)) return null;
  return teamId;
}

export const NBA_SIMILAR_SEASON_DISPLAY = {
  statLabel: nbaSimilarityStatLabel,
  formatStat: formatNbaSimilarityStat,
  teamLabel: nbaTeamLabel,
  teamLogoId: nbaTeamLogoId,
};
